import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaMoneyBillWave } from 'react-icons/fa';

const EmptyState = ({ onAddTransaction, hasFilters = false }) => {
  const { t } = useTranslation();

  return (
    <div className="empty-state">
      <FaMoneyBillWave className="empty-state-icon" />
      <h3>{hasFilters ? t("No matching transactions") : t("No transactions found")}</h3>
      <p>
        {hasFilters
          ? t("Try adjusting your filters")
          : t("Start tracking your financial transactions")}
      </p>
      {!hasFilters && (
        <button className="add-transaction-btn" onClick={onAddTransaction}>
          {t("Add your first transaction")}
        </button>
      )}
    </div>
  );
};

export default EmptyState;